import { StaticAuthProvider } from '@twurple/auth';
import { ApiClient, HelixStream } from '@twurple/api';
import moment from 'moment';
import LocalStorage from '../LocalStorage';

const CLIENT_ID = 'urulyas98puhy0008o35qgj3298yos';

const SCOPE = [
  'user:read:email',
  'user:read:follows',
  'user:edit:follows'
];

export function getAuthProvider() {
  const accessToken = localStorage.getItem('accessToken');
  if (!accessToken) return;
  return new StaticAuthProvider(CLIENT_ID, accessToken);
}

export interface LiveStreams {
  username: string,
  id: string,
  title: string,
  uptime: string,
  viewers: number,
  thumbnail: string,
  tags: string,
  notes: string
}

async function apiClient() {
  const authProvider = getAuthProvider();
  if (!authProvider) {
    console.error('could not get authprovider');
    return;
  }
  const client = new ApiClient({ authProvider: authProvider });
  return client;
}

export async function getLiveStream(username: string): Promise<HelixStream | undefined> {
  console.log('is online?', username);
  const client = await apiClient();
  if (!client) return;
  const user = await client.users.getUserByName(username);
  if (!user) return;
  const result = await client.streams.getStreamByUserId(user.id);
  if (!result) return;
  return result;
}

export async function getLiveStreams(height = 100, width = 150): Promise<LiveStreams[]> {
  const client = await apiClient();
  if (!client) return [];
  const userId = localStorage.getItem('userId');
  if (!userId) return [];
  const user = await client.users.getUserById(userId);
  if (!user) return [];
  let streams: HelixStream[] = [];
  let done = false;
  let options: any = { limit: 100 };
  while (!done) {
    const request = await client.streams.getFollowedStreams(user, options);
    streams = [...streams, ...request.data];
    if (request.cursor) {
      options.after = request.cursor;
    } else {
      done = true;
    }
  }

  const following = streams.map((stream) => {
    return {
      username: stream.userDisplayName,
      id: stream.userId,
      title: stream.title,
      uptime: calculateUptime(stream.startDate),
      viewers: stream.viewers,
      thumbnail: stream.thumbnailUrl.replace('{width}', width.toString()).replace('{height}', height.toString()),
      tags: LocalStorage.instance.getTags(stream.userId),
      notes: LocalStorage.instance.getNotes(stream.userId),
    }
  });

  return following;
}

function calculateUptime(startDate: Date) {
  const duration = moment.duration(moment().diff(startDate));
  const hours = duration.hours();
  const minutes = duration.minutes();
  const h = (hours < 10) ? `0${hours}` : `${hours}`;
  const m = (minutes < 10) ? `0${minutes}` : `${minutes}`;
  return `${h}h ${m}m`;
}


export function login() {
  console.log('login');
  const redirecturl = (/localhost/.test(window.location.host))
    ? 'http://localhost:3000/auth'
    : 'https://triode-tools.web.app/auth';

  window.location.href = `https://id.twitch.tv/oauth2/authorize?` +
    [
      `client_id=${CLIENT_ID}`,
      `redirect_uri=${redirecturl}`,
      `response_type=token`,
      `scope=` + SCOPE.join(' ')
    ].join('&');
}

export function checkToken() {
  console.log('checking token');
  try {
    const params = new URLSearchParams(window.location.hash.replace('#', ''));
    const accessToken = params.get('access_token');
    if (accessToken) {
      localStorage.setItem('accessToken', accessToken);
      console.log('Saved access token', accessToken);
      (async () => {
        console.log(`OAuth: ${accessToken}`);
        const result = await fetch('https://id.twitch.tv/oauth2/validate', {
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        });
        console.log(result);
        if (result) {
          const data = await result.json();
          console.log(data);
          localStorage.setItem('clientId', data['client_id']);
          localStorage.setItem('userId', data['user_id']);
          localStorage.setItem('scopes', data['scopes']);
          localStorage.setItem('username', data['login']);
          window.location.href = '/main';
        } else {
          window.location.href = '/';
        }
      })();
    }
  } catch(e) {
    return null;
  }
}